import userProfileService from '@/services/security/user-profile.service'
import findIndex from 'ramda/src/findIndex'
import propEq from 'ramda/src/propEq'

class UsersService {
  constructor() {
    this.usersWaitingForAuth0Deletion = []
  }

  addUserWaitsForDeletion(user) {
    this.usersWaitingForAuth0Deletion.push(user)
  }

  userIsWaitingForDeletion(user) {
    const userIndex = findIndex(propEq('id', user.id))(this.usersWaitingForAuth0Deletion)
    return userIndex >= 0
  }

  isDeleteUserAllowed(user) {
    return user.id !== userProfileService.getUserId()
  }
}

export default new UsersService()
